import React, { useState } from 'react';
import { Modal, Input } from 'antd';
// 使用 window.message 代替 antd 静态方法，避免 context 警告
import { StarOutlined } from '@ant-design/icons';

/**
 * 申请入团 Modal 组件
 * @param {Object} props - 组件属性
 * @param {boolean} props.visible - 是否显示 modal
 * @param {Function} props.onCancel - 取消回调
 * @param {Function} props.onOk - 确认回调
 * @param {string} props.workspaceName - 工作区名称
 * @param {string} props.workspaceId - 工作区ID
 * @returns {ReactElement} 申请入团 Modal 组件
 */
const ApplyToJoinModal = ({ 
  visible, 
  onCancel, 
  onOk, 
  workspaceName = '',
  workspaceId = ''
}) => {
  const [applicationMessage, setApplicationMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleOk = async () => {
    if (!applicationMessage.trim()) {
      window.message?.warning('请输入申请理由');
      return;
    }

    setLoading(true);
    try {
      await onOk(applicationMessage);
      setApplicationMessage('');
      window.message?.success('申请已发送');
    } catch (error) {
      console.error('申请失败:', error);
      window.message?.error(error.message || '申请失败，请重试');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setApplicationMessage('');
    onCancel();
  };

  return (
    <Modal
      open={visible}
      onCancel={handleCancel}
      onOk={handleOk}
      title={
        <div className="flex items-center gap-2">
          <StarOutlined className="text-pink-500" />
          <span className="text-lg font-medium">申请加入该Workspace</span>
        </div>
      }
      okText="发送"
      cancelText="取消"
      confirmLoading={loading}
      width={500}
      centered
    >
      <div className="py-4">
        <div className="mb-4">
          <div className="text-sm text-gray-600 mb-2">申请理由</div>
          <Input.TextArea
            value={applicationMessage}
            onChange={(e) => setApplicationMessage(e.target.value)}
            placeholder="请输入"
            rows={2}
            maxLength={50}
            showCount
            className="w-full"
          />
        </div>
      </div>
    </Modal>
  );
};

export default ApplyToJoinModal; 